module.exports = {
    MARKETING: "marketing",
    PROJECT_MANAGEMENT: "project_management",
    CRM: "sales_customers",
    SOFTWARE_DEVELOPMENT: "software_development",
    HR: "hr",
    DESIGN: "design",
    CONTENT_PRODUCTION: "content_production",
    FREELANCERS: "freelancers",
    OPERATIONS: "office_operations",
    STARTUP: "startup",
    EDUCATION: "education",
    REAL_ESTATE: "real_estate",
    CONSTRUCTION: "construction",
    HOME_ID: "home",
    FEATURED_TEMPLATES: "featured_templates",
    AI_CREATE: "ai_create"
};
